import React from "react";

import "./styles.less";
import { useTranslation } from "react-i18next";
import Masonry, { ResponsiveMasonry } from "react-responsive-masonry";

export const HeighEducateChallenge = (props) => {
  const { t } = useTranslation();
  const { challenges, scale, theme } = props;
  return (
    <section>
      <div className="heigh-educate-challenge">
        <div className="inner">
          <h2 className="customer-title">
            {t("customer.heigh-educate.challenge.title")}
          </h2>
          <div className="customer-challenge-responsive">
            <ResponsiveMasonry columnsCountBreakPoints={scale}>
              <Masonry columnsCount={4} gutter={70}>
                {challenges.map((challenge, idx) => {
                  return (
                    <div
                      className="card"
                      key={`heigh-educate.challenge-${idx}`}
                    >
                      <div className="title-warp">
                        <span
                          className="doc"
                          style={{ background: theme }}
                        ></span>
                        <span className="title">{challenge.title}</span>
                      </div>
                      <div className="text">{challenge.description}</div>
                    </div>
                  );
                })}
              </Masonry>
            </ResponsiveMasonry>
          </div>
        </div>
      </div>
    </section>
  );
};
